<template>
 <v-container fluid>
  <v-row justify="center" align="center">
    <v-col md="6">
      <v-img width="330" contain src="@/assets/benefits/Group1.svg"/>
    </v-col>
    <v-col md="6">
      <v-img width="330" contain src="@/assets/benefits/Group2.svg"/>
    </v-col>
  </v-row>
  <v-row>
    <v-col md="6">
      <v-img width="330" contain src="@/assets/benefits/Group3.svg"/>
    </v-col>
    <v-col md="6">
      <v-img width="330" contain src="@/assets/benefits/Group4.svg"/>
    </v-col>
  </v-row>
  <v-row justify="center" align="center">
    <v-col md="6">
      <v-img width="330" contain src="@/assets/benefits/Group5.svg"/>
    </v-col>
    <v-col md="6">
      <v-img width="330" contain src="@/assets/benefits/Group6.svg"/>
    </v-col>
  </v-row>
  <v-row>
    <v-col md="6">
      <v-img width="330" contain src="@/assets/benefits/Group7.svg"/>
    </v-col>
    <v-col md="6">
      <v-img width="330" contain src="@/assets/benefits/Group8.svg"/>
    </v-col>
  </v-row>
 </v-container>
</template>
<script>
export default {
    name: "benefits-faqs",
}
</script>
<style scoped>

</style>